export const WEBVIEW_REGEX = new RegExp('iPhone|iPad|Android')
export const isAndroid = /Android/i.test(navigator.userAgent)
export const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
